<template>
  <div class="container">
    <FilteredProducts />
  </div>
</template>

<script>
import FilteredProducts from "@/esf_antarctica_lederhosenland/core/components/category-product/FilteredProducts.vue";
export default {
  name: "CategoryPageContent",
  components: {
    FilteredProducts,
  },
};
</script>

<style lang="scss" scoped>
.load-more {
  font-size: 16px;
}
</style>
